export default ['alt', 'ctrl', 'meta', 'shift', 'cmd'];